/**
 * Shared chart configuration for admin and brand dashboards.
 * Single source of truth for range options, label formatting, and colors.
 */

const monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

/** Unified range options — used by both admin and brand dashboards. */
export const chartRanges = [
  { label: '7 Days', value: '7d' },
  { label: '30 Days', value: '30d' },
  { label: '90 Days', value: '90d' },
  { label: 'Year', value: '1y' },
  { label: 'All Time', value: 'all' },
];

export const DEFAULT_RANGE = '30d';

/**
 * Format a chart data point label based on granularity.
 * - Daily: "Mon 4/7" (day name + month/day)
 * - Monthly: "Apr '26"
 */
export const formatLabel = (item) => {
  if (!item?.month || !item?.year) return 'N/A';

  if (item.granularity === 'daily' && item.day) {
    const d = new Date(Date.UTC(item.year, item.month - 1, item.day));
    const dayName = dayNames[d.getUTCDay()];
    return `${dayName} ${item.month}/${item.day}`;
  }

  const name = monthsShort[item.month - 1] || '???';
  const yr = String(item.year).slice(-2);
  return `${name} '${yr}`;
};

/**
 * Build chart labels with partial indicator.
 */
export const buildLabels = (data) =>
  (data || []).map((item) => {
    const label = formatLabel(item);
    return item.isPartial ? `${label} *` : label;
  });

/**
 * Build bar colors with partial month lighter.
 */
export const buildBarColors = (data, color = 'rgba(54, 47, 217, 0.85)', partialColor = 'rgba(54, 47, 217, 0.35)') =>
  (data || []).map((item) => item.isPartial ? partialColor : color);

/**
 * Build point config for line charts with partial indicator.
 */
export const buildPointConfig = (data) => ({
  pointRadius: (data || []).map((item) => item.isPartial ? 5 : 3),
  pointBackgroundColor: (data || []).map((item) =>
    item.isPartial ? 'rgba(54, 47, 216, 0.4)' : 'rgba(54, 47, 216, 1)'
  ),
  pointStyle: (data || []).map((item) => item.isPartial ? 'rectRot' : 'circle'),
});
